import { render, staticRenderFns } from "./SportSelector.vue?vue&type=template&id=5a552afc&"
import script from "./SportSelector.vue?vue&type=script&lang=ts&"
export * from "./SportSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports